export default __webpack_public_path__ + "static/goods-g-4e7df0b8c90854172f36ad6aa8a0fc45.png";